import React, { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import { TextField } from '@material-ui/core';

import './style.scss';

const defaultInputStyle = {
  backgroundColor: 'white',
  boxSizing: 'border-box',
  height: 40,
  border: '1px solid rgb(195, 195, 195)',
  fontSize: 16,
  paddingRight: '2px !important',
  width: '100%',
};

function NumberFormatCustom(props: any) {
  const [valueState, setValueState] = useState(props.value);

  useEffect(() => {
    if (!props.register && valueState !== props.value) {
      setValueState(props.value);
    }
  }, [props.value]);

  const {
    inputRef,
    suffixSign,
    prefixSign,
    value,
    scale,
    onChange,
    className,
    allowNegative = false,
    disabled,
    ...other
  } = props;

  return props.register ? (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      className={className}
      allowNegative={allowNegative}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      decimalScale={props.scale ? props.scale : 0}
      isNumericString
      suffix={suffixSign}
      prefix={prefixSign}
    />
  ) : (
    <NumberFormat
      getInputRef={inputRef}
      className={className}
      allowNegative={allowNegative}
      disabled={disabled}
      value={value}
      // DON'T RELEASE THE KRAKEN
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      decimalScale={props.scale ? props.scale : 0}
      suffix={suffixSign}
      prefix={prefixSign}
    />
  );
}

export function EeNumber(props: any) {
  const [valueState, setValueState] = useState(props.value);

  useEffect(() => {
    if (!props.register && valueState !== props.value) {
      setValueState(props.value);
    }
  }, [props.value]);

  const {
    inputStyle = defaultInputStyle,
    name,
    disabled,
    register,
    defaultValue,
  } = props;

  return props.register ? (
    <TextField
      InputProps={{
        style: inputStyle,
        inputComponent: NumberFormatCustom as any,
        inputProps: {
          suffixSign: props.suffix,
          value: props.value,
          prefixSign: props.prefix,
          allowNegative: props.allowNegative ? props.allowNegative : false,
          register: register,
        },
      }}
      inputRef={register}
      name={name}
      defaultValue={defaultValue}
      variant="outlined"
      disabled={disabled}
      onBlur={() => {}}
      onChange={props.onChange}
      onFocus={props.onFocus}
    />
  ) : (
    <TextField
      InputProps={{
        style: inputStyle,
        inputComponent: NumberFormatCustom as any,
        inputProps: {
          suffixSign: props.suffix,
          value: props.value,
          allowNegative: props.allowNegative ? props.allowNegative : false,
          prefixSign: props.prefix,
        },
      }}
      name={name}
      variant="outlined"
      disabled={disabled}
      onChange={(e) => {
        // DON'T RELEASE THE KRAKEN
        if (props.onChange) {
          props.onChange(e);
        }
      }}
    />
  );
}
